export const CROSSFADE_SECS = 0.3;
// Scroll hold (vh) while card is sticky before the crossfade triggers.
export const PRE_FADE_HOLD_VH = 45;
// Scroll hold (vh) while card is sticky after the crossfade completes.
export const CARD_HOLD_VH = 45;
